import z from 'zod';
import type { ArtifactKind } from '@/features/artifacts/types';
import { sheetSearchSchema } from '@/features/sheets/constants';

export const ARTIFACT_BATCH_LIMIT = 100;

export const ARTIFACT_EXTENSIONS: Record<ArtifactKind, string> = {
  document: 'docx',
  spreadsheet: 'xlsx',
  pdf: 'pdf',
  presentation: 'pptx',
  sheet: 'xlsx',
};

export const ARTIFACT_KIND_TEXT: Record<ArtifactKind, { en: string; nb: string }> = {
  document: { en: 'Document', nb: 'Dokument' },
  spreadsheet: { en: 'Spreadsheet', nb: 'Regneark' },
  pdf: { en: 'PDF', nb: 'PDF' },
  presentation: { en: 'Presentation', nb: 'Presentasjon' },
  sheet: { en: 'Sheet', nb: 'Ark' },
};

export const artifactsSearchSchema = z.object({
  tab: z.enum(['all', 'mine', 'shared']).default('all').catch('all'),
});

export const artifactSearchSchema = sheetSearchSchema.extend({
  revision: z.coerce.number().int().positive().optional(),
});
